import hcAxios from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'
// 官方社群相关接口
enum API {
  // 查询帮助中心链接列表
  CmsCommunityLinks = '/hk-web/cms/community/links',
}

export type TGetCmsCommunityLinksParams = any
export type TGetCmsCommunityLinksResponse = TResponse<
  {
    id?: number // ID
    linkAndroid?: string // Android链接
    linkIos?: string // iOS链接
    linkWeb?: string // 网页链接
    name?: string // 社群名称
  }[]
>
export const getCmsCommunityLinks = (params?: TGetCmsCommunityLinksParams) => {
  return hcAxios.get<TGetCmsCommunityLinksResponse>(API.CmsCommunityLinks, { params })
}
